import { GridSize } from '@mui/material';
import { TraceHistoryMap, HistoryState, TraceHistoryAction } from '../types';

export const initialHistoryState: HistoryState = {
  traceHistory: null,
  traceCount: {
    1: 0,
    2: 0,
  },
  noDataFlag: false,
  isHistoryLoading: false,
  multiHistory: false,
  showMarkerHistory: false,
  smallestTraceHistoryLength: 0,
  graphSize: 12,
  hideDetectorNames: false,
};

export function traceHistoryReducer(
  state: HistoryState,
  action: TraceHistoryAction
) {
  switch (action.type) {
    case 'RESET-STATE':
      return initialHistoryState;
    case 'LOAD-HISTORY':
      return {
        ...state,
        noDataFlag: false,
        dateFlag: false,
        isHistoryLoading: true,
        traceHistory: null,
      };
    case 'HISTORY-COUNT-LOADED': {
      const { trace_count } = action.payload;
      return {
        ...state,
        traceCount: {
          1: trace_count,
          2: 0,
        },
      };
    }
    case 'HISTORY-LOADED': {
      const { historyData } = action.payload;
      const { historyOne, historyTwo } = historyData;
      const historyOneCount = Number(state.traceCount[1]);
      const historyTwoCount = Number(state.traceCount[2]);

      if (historyOne === undefined || historyTwo === undefined) return state;

      const noData = historyOneCount === 0 && historyTwoCount === 0;
      const multiHistory = historyOneCount > 0 && historyTwoCount > 0;
      const graphSize: GridSize = multiHistory ? 6 : 12;

      let traceHistory: TraceHistoryMap | null = {
        1: historyOne,
        2: historyTwo,
      };

      if (noData) traceHistory = null;

      let smallestTraceHistoryLength = historyOneCount;

      if (historyTwoCount < smallestTraceHistoryLength) {
        smallestTraceHistoryLength = historyTwoCount;
      }

      return {
        ...state,
        traceHistory: traceHistory,
        isHistoryLoading: false,
        noDataFlag: noData,
        multiHistory: multiHistory,
        smallestTraceHistoryLength: smallestTraceHistoryLength,
        graphSize: graphSize,
      };
    }
    case 'TOGGLE-HIDE-DETECTOR-NAMES': {
      return { ...state, hideDetectorNames: !state.hideDetectorNames };
    }
    case 'TOGGLE-MARKER-HISTORY': {
      const markerHistoryEnabled = !state.showMarkerHistory;
      let graphSize: GridSize = 12;

      if (markerHistoryEnabled) graphSize = 6;
      else {
        if (!state.traceHistory) graphSize = 12;
        if (
          state.traceHistory &&
          state.traceHistory[1].length > 0 &&
          state.traceHistory[2].length > 0
        )
          graphSize = 6;
      }

      return {
        ...state,
        showMarkerHistory: markerHistoryEnabled,
        graphSize: graphSize,
      };
    }

    default:
      return state;
  }
}
